//
import { mapActions } from "vuex"

//
import { ModelDataTable, ModelForm } from "@/components/reusable_components/next"
import QueryModel from "@/models/General/GQuery"

//
import fields from "./fields"

//
export default {
    name: "query-create",
    components: {
        ModelDataTable,
        ModelForm,
    },
    computed: {

        /**
         * 
         */
        formProps () {
            return {
                fields,
            }
        },
        
        /**
         * 
         */
        tableProps () {
            return {
                headers : this.tableHeaders,
                parser  : this.parser,
                service : this.tableService,
            }
        },
    },
    data () {
        return {
            formData    : {},
            tableHeaders: [],
            tableService: null,
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * 
         */
        clean () {
            this.tableService = null
        },

        /**
         * 
         */
        fetch () {
            QueryModel.modeler().find( this.$route.params.id ).then( this.setFormData )
        },

        /**
         * 
         */
        mapHeader ( header ) {
            return {
                text    : header,
                value   : header,
            }
        },

        /**
         * 
         */
        parser ( res ) {

            //
            let { result } = res.slice().pop()

            //
            this.tableHeaders = Array.isArray( result.data ) ? Object.keys( result.data.slice().pop() ).map( this.mapHeader ) : Object.keys( result.data[ Object.keys( result.data ).slice().pop() ] ).map( this.mapHeader )

            //
            return result
        },

        /**
         * 
         */
        raw ( model ) {
            this.service = new QueryModel({ id: "run" })
        },

        /**
         * 
         */
        reset () {
            this.fetch()
            this.clean()
        },

        /**
         * 
         */
        setFormData ( model ) {
            this.formData = model.reset()
        },

        /**
         * 
         */
        async submit ( model ) {
            this.tableService = {
                async fetchDataTable ( limit, page, sort, params ) {
                    return await model.run().limit( limit ).page( page ).orderBy( sort ).params( params ).get()
                }
            }
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Ejecutar consulta" )
    },
    mounted () {
        this.reset()
    }
}